import { useIntl } from '../../hooks/useIntl.js';
import type { AppUser } from '../../types/user.js';
import { TagBadge } from './TagBadge';

type UserAccessProps = {
  user: Pick<AppUser, 'role' | 'grants'>;
};

export function UserAccess({ user }: UserAccessProps) {
  const intl = useIntl();

  if (user.role === 'admin') {
    return (
      <span className="text-sm" data-testid="user-access-admin">
        {intl.formatMessage({ id: 'users.table.accessAdmin' })}
      </span>
    );
  }

  if (user.grants.length === 0) {
    return <span className="text-xs text-foreground">—</span>;
  }

  return (
    <div className="flex flex-col gap-1">
      {user.grants.map((grant) => (
        <div
          key={grant.tagId}
          className="flex items-center gap-1 text-xs"
          data-testid="user-access-grant"
        >
          <TagBadge tag={{ id: grant.tagId, name: grant.tagName }} />
          <span>· {intl.formatMessage({ id: `userGrants.role.${grant.role}` })}</span>
        </div>
      ))}
    </div>
  );
}
